import * as React from 'react';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import BottomNavigation from '@mui/material/BottomNavigation';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import { withStyles } from "@material-ui/core/styles";


const CustoBottomNavigation = withStyles({
    root: {
        backgroundColor: "#16314c",
    }
})(BottomNavigation);

const CustoButton = withStyles({
    root: {
        width: "100%",
        color: "#fff2d7"
    }
})(Button);

export default function FixedBottomNavigation(props) {
    const [value, setValue] = React.useState(0);
    const ref = React.useRef(null);

    return (
        <Box sx={{ pb: 7 }} ref={ref}>
            <CssBaseline />
            <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0 }} elevation={3}>
                <CustoBottomNavigation>
                    <CustoButton color="success" onClick={() => props.setOpenCart(true)}>{"ORDINA"}</CustoButton>
                </CustoBottomNavigation>
            </Paper>
        </Box>
    );
}
